import React, { Component } from "react";
import Select from "react-select";
import Modal from "react-modal";
import ReactTooltip from "react-tooltip";
import { connect } from "react-redux";
import { Datepicker, UsersSelect } from "../../_components";
import { userActions } from "../../_actions";
import moment from "jalali-moment/jalali-moment";
import "../../assets/css/eop.css";
import { Progress } from "reactstrap";
import standingPerson from "../../assets/images/bg_002.png";
import { formatDate } from "../../_helpers/formatDate";
Modal.setAppElement("#root");

class Eop_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      eop_number: "",
      eop_certificate: "",
      start_atUnFormated: "",
      start_atUnix: "",
      start_at: "",
      start_at_temp: null,
      finish_atUnFormated: "",
      finish_atUnix: "",
      finish_at: "",
      finish_at_temp: null,
      subject: "",
      description: "",
      referrer_person: null,
      responsible_person: "",
      priority_status: "",
      priority_status_temp: "",
      partners: [],
      hospital_id: "",
      complete_percent: "",
      has_eop_step: "",
      status: "",
      kartabl_certificate: "",
      committee_id: "",
      year: "",
      mehvar: "بهبود کیفیت",
      mehvar_icon: "",
      steps: [],
      steps_storage: [],
      step_description: null,
      timeZone: "",
      todaysDate: "",
      isEditing: false,
      isClickedOnDatePickerFinish: false,
      isClickedOnDatePickerStart: false,
      prefix: "new_indicator_interval",
      putId: "",
      mehvar_object: { name: "بهبود کیفیت", id: 1 },
      referrer_person_object: null,
      masoleanjam_modal: false,
      MonitorModal: false,
      edit_id: "",
      modalPartnerNum: 0,
      startDateRested: false,
      finishDateRested: false,
    };
    this.config = {
      headers: {
        Authorization: this.props.globalStorage.token,
      },
    };
    this.globalStorage = this.props.globalStorage;
    this.referrer_person_options = this.globalStorage.users.map((user) => {
      return {
        name: `${user.fn} ${user.ln}`,
        id: user.id,
      };
    });
  }

  componentDidMount = () => {
    this.setUpEopData();
    this.getTimeZone();
    // this.getDate();
    document.querySelector(".wave").classList.add("hidden");
  };

  componentWillUnmount = () => {
    document.querySelector(".wave").classList.remove("hidden");
  };

  getNameById = (targetId, withPost = false, onlyPost = false, obj = false) => {
    const user = this.globalStorage.users.filter(
      (user) => user.id === +targetId
    )[0];
    // const user2 = this.globalStorage.users.filter(
    //   (user) => user.id === targetId.id
    // )[0];

    if (user === undefined || targetId === undefined) return;
    if (obj) return user;
    if (withPost) return `${user.fn} ${user.ln}${" (" + user.post + ")"}`;
    if (onlyPost) return user.post;
    return `${user.fn} ${user.ln}`;
  };

  addPartners = (partners) => {
    this.setState({ partners });
  };

  goBack = () => {
    this.props.history.goBack();
  };

  setUpEopData = () => {
    const data = this.props.eopData;
    data &&
      this.setState({
        id: data.id,
        eop_number: data.eop_number,
        eop_certificate: data.eop_certificate,
        start_at: data.start_at,
        finish_at: data.finish_at,
        subject: data.subject,
        description: data.description,
        referrer_person: data.referrer_person,
        responsible_person: data.responsible_person,
        priority_status: data.priority_status,
        partners: data.partners === null ? [] : data.partners,
        hospital_id: data.hospital_id,
        complete_percent: data.complete_percent,
        has_eop_step: data.has_eop_step,
        status: data.status,
        kartabl_certificate: data.kartabl_certificate,
        committee_id: data.committee_id,
        year: data.year,
        mehvar: data.mehvar,
        mehvar_icon: data.mehvar_icon,
        mehvar_object: { name: data.mehvar, id: 1 },
        steps: data.steps,
        steps_storage: data.steps,
      });
  };

  getData = () => {
    this.props
      .dispatch(
        userActions.API(
          "get",
          `v2/get_indicator_interval_averages?indicator_id=${this.listId}`,
          null,
          true
        )
      )
      .then((response) => {
        const data = response.data.intervals[this.intervalIndex].eop;
        data &&
          this.setState({
            id: data.id,
            eop_number: data.eop_number,
            eop_certificate: data.eop_certificate,
            start_at: data.start_at,
            finish_at: data.finish_at,
            subject: data.subject,
            description: data.description,
            referrer_person: data.referrer_person,
            responsible_person: data.responsible_person,
            priority_status: data.priority_status,
            partners: data.partners === null ? [] : data.partners,
            hospital_id: data.hospital_id,
            complete_percent: data.complete_percent,
            has_eop_step: data.has_eop_step,
            status: data.status,
            kartabl_certificate: data.kartabl_certificate,
            committee_id: data.committee_id,
            year: data.year,
            mehvar: data.mehvar,
            mehvar_icon: data.mehvar_icon,
            mehvar_object: { name: data.mehvar, id: 1 },
            steps: data.steps,
          });
      });
  };

  postData = (e) => {
    e.preventDefault();
    let sortedDates = this.sortDates();

    const data = {
      committee_id: this.state.committee_id,
      complete_percent: 0,
      description: this.state.description,
      eop_certificate: `${this.state.prefix}${this.props.intervalData.id}`,
      eop_number: this.state.eop_number,

      // finish_at: this.state.finish_at,
      finish_at: sortedDates[sortedDates.length - 1],

      has_eop_step: this.state.has_eop_step,
      hospital_id: this.state.hospital_id,
      id: this.props.intervalData.id,
      // id: this.state.id,
      kartabl_certificate: this.state.kartabl_certificate,
      mehvar: this.state.mehvar,
      mehvar_icon: "icon icon-improve_quality",
      partners: [],
      prefix: this.state.prefix,
      priority_status: this.state.priority_status
        ? this.state.priority_status
        : this.state.priority_status_temp,
      referrer_person: this.state.referrer_person,
      responsible_person: this.state.responsible_person,
      save: false,

      // start_at: this.state.start_at,
      start_at: sortedDates[0],

      status: this.state.status,
      steps: this.state.steps,
      subject: this.state.subject,
      year: +this.globalStorage.year,
      $$hashKey: `object:${this.state.id}`,
    };

    const dataPut = {
      description: this.state.description,

      // finish_at: this.state.finish_at,
      finish_at: sortedDates[sortedDates.length - 1],

      // id: this.props.intervalData.id,
      id: this.state.id,
      eop_id: this.state.id,
      // id: this.state.putId,
      mehvar: this.state.mehvar,
      mehvar_icon: "icon icon-improve_quality",
      partners: [],
      //partners: this.state.partners,
      prefix: this.state.prefix,
      priority_status: this.state.priority_status,
      responsible_person: this.state.responsible_person,
      save: false,

      // start_at: this.state.start_at,
      start_at: sortedDates[0],

      status: this.state.status,
      steps: this.state.steps,
      subject: this.state.subject,
      year: +this.globalStorage.year,

      // committee_id: this.state.committee_id,
      // complete_percent: 0,
      // eop_certificate: `${this.state.prefix}${this.props.intervalData.id}`,
      // eop_number: this.state.eop_number,
      // has_eop_step: this.state.has_eop_step,
      // hospital_id: this.state.hospital_id,
      // kartabl_certificate: this.state.kartabl_certificate,
      //   ? this.state.priority_status
      //   : this.state.priority_status_temp,
      // referrer_person: this.state.referrer_person,
      // $$hashKey: `object:${this.state.id}`,
    };

    this.props.eopData
      ? this.props
          .dispatch(
            userActions.API(
              "put",
              `v1/user/hospital/eop/submit?eop_id=${this.state.id}`,
              dataPut,
              true,
              false
            )
          )

          .then((response) => {
            this.props.refreshIndicatorEop();
          })
      : this.props
          .dispatch(
            userActions.API(
              "post",
              `v1/user/hospital/eop/submit`,
              data,
              true,
              false
            )
          )
          .then((response) => {
            // this.setState({ putId: response.data.id });
            this.props.refreshIndicatorEop();
          });
  };

  getTimeZone = () => {
    this.props
      .dispatch(userActions.API("get", `v1/time`, null, true, false))
      .then((response) => {
        this.setState({
          timeZone: response.data.split("+")[1],
          todaysDate: response.data,
        });
      })
      .catch((error) => {
        console.error("Error reviving data:", error);
      });
  };

  toUTC = (date, timeZone) => {
    return (
      moment(date, "jYYYY/jMM/jDD").locale("en").format("YYYY-MM-DDTHH:mm:ss") +
      "+" +
      timeZone
    );
  };

  safeValue = (str) => {
    if ([null, undefined].includes(str)) {
      return "";
    }
    return str;
  };

  handleCancel = () => {
    this.setState({
      step_description: null,
      responsible_person: "",
      referrer_person_object: null,
      isEditing: false,
      edit_id: "",
    });
  };

  handleEdit = (e, i, state) => {
    e.preventDefault();

    if (this.state.status === "deactive") {
      userActions.failure("فقط در حالت فعال بودن گام امکان ویرایش وجود دارد.");
    }

    if (state === "setup") {
      this.setState({
        step_description: this.state.steps[i].description,
        start_at_temp: this.state.steps[i].start_at,
        finish_at_temp: this.state.steps[i].finish_at,
        status: this.state.steps[i].status,
        responsible_person: this.state.steps[i].responsible_person,
        referrer_person_object: {
          name: this.getNameById(this.state.steps[i].responsible_person),
          id: this.state.steps[i].responsible_person,
        },
        partners: this.state.steps[i].partners
          ? this.state.steps[i].partners.map((partner) =>
              this.getNameById(partner, false, false, true)
            )
          : [],

        isEditing: true,
        edit_id: this.state.steps[i].id,
      });
    } else if (state === "submit") {
      this.setState({
        step_description: null,
        startDateRested: true,
        start_at_temp: "",
        start_atUnix: "",
        start_atUnFormated: "",
        isClickedOnDatePickerStart: false,
        finishDateRested: true,
        finish_at_temp: "",
        finish_atUnFormated: "",
        isClickedOnDatePickerFinish: false,
        responsible_person: "",
        referrer_person_object: null,
        isEditing: false,
        edit_id: "",
        partners: [],
        steps: this.state.steps.map((step) => {
          if (step.id === this.state.edit_id) {
            return {
              ...step,
              description: this.state.step_description,

              start_at: this.state.start_at_temp,
              start_atUnix: this.state.start_atUnix,
              start_atUnFormated: this.state.start_atUnFormated,

              finish_at: this.state.finish_at_temp,
              finish_atUnix: this.state.finish_atUnix,
              finish_atUnFormated: this.state.finish_atUnFormated,

              responsible_person: this.state.responsible_person,
              partners: this.state.partners.map((partner) =>
                typeof partner === "number" ? partner : +partner.id
              ),
            };
          }
          return step;
        }),
      });
    }
  };

  handleAddStep = () => {
    let sortedDates = this.sortDates();
    this.setState({
      step_description: null,

      startDateRested: true,
      start_at: sortedDates[0],
      start_at_temp: "",
      start_atUnFormated: "",
      start_atUnix: "",

      finishDateRested: true,
      finish_at: sortedDates[sortedDates.length - 1],
      finish_at_temp: "",
      finish_atUnFormated: "",
      finish_atUnix: "",

      referrer_person: "",
      responsible_person: "",
      referrer_person_object: null,
      partners: [],
      steps: [
        ...this.state.steps,
        {
          temp_id: this.state.steps.length,
          eop_id: this.state.id,
          description: this.state.step_description,
          start_at: this.state.start_at_temp,
          finish_at: this.state.finish_at_temp,
          responsible_person: this.state.responsible_person,
          referrer_person: this.state.referrer_person,
          complete_percent: 0,
          partners: this.state.partners.map((partner) => Number(partner.id)),
          status: "active",
          actions: [],
        },
      ],
    });
    // this.handleChangeFinishDate("", "", true);
  };

  handleMasoleanjam = (n) => {
    this.setState({ MonitorModal: true, modalPartnerNum: n });
  };

  handleCloseMasoleanjam = () => {
    this.setState({ MonitorModal: false });
  };

  sortDates = () => {
    const res = this.state.steps
      .map((step) => [step.start_at, step.finish_at])
      .flat()
      .sort((a, b) => a - new Date(b).getTime(), 0);
    return res;
  };

  // handleChangeFinishDate = (unix, formatted, reset = false) => {
  //   reset
  //     ? this.setState({
  //         finish_atUnix: "",
  //         finish_atUnFormated: "",
  //         finish_at_temp: "",
  //         finish_at: unix,
  //       })
  //     : this.setState({
  //         finish_atUnix: unix,
  //         finish_atUnFormated: formatted,
  //         finish_at_temp: this.toUTC(formatted, this.state.timeZone),
  //       });
  // };

  render() {
    console.log(this.state.start_at_temp);
    console.log(this.state.finish_at_temp);

    return (
      <Container className="eop__container u-background-white">
        <Container className="left-part">
          <Container className="left-part__content-container u-pad-top--big">
            <Card className="left-part__card">
              <Container className="btns-container u-pad-side-small">
                <div className="gap-10 w-100  d-flex flex-row-reverse mt-4">
                  <Datepicker
                    value={
                      this.state.finish_at_temp
                        ? moment(
                            this.state.finish_at_temp
                              .split("T")[0]
                              .replace(/-/g, "/"),
                            "YYYY/MM/DD"
                          )
                            .locale("fa")
                            .format("jYYYY/jMM/jDD")
                        : undefined
                    }
                    onChange={(val) => this.setState({ finish_at_temp: val })}
                    placeholder="انتخاب تاریخ پایـان"
                  />
                  <Datepicker
                    value={
                      this.state.start_at_temp
                        ? moment(
                            this.state.start_at_temp
                              .split("T")[0]
                              .replace(/-/g, "/"),
                            "YYYY/MM/DD"
                          )
                            .locale("fa")
                            .format("jYYYY/jMM/jDD")
                        : undefined
                    }
                    onChange={(val) => this.setState({ start_at_temp: val })}
                    placeholder="انتخاب تاریخ شـروع"
                  />
                </div>
                <Select
                  className="u-mg-top--small custom-select-2 select-special"
                  value={this.state.referrer_person_object}
                  placeholder="مسئـول انجـام/ آگاهـی"
                  onChange={(e) =>
                    this.setState({
                      responsible_person: e.id,
                      referrer_person_object: {
                        name: e.name,
                        id: e.id,
                      },
                    })
                  }
                  options={this.referrer_person_options}
                  getOptionLabel={(opt) => opt.name}
                  getOptionValue={(opt) => opt.id}
                />
                {this.state.responsible_person ? (
                  <UsersSelect
                    className="btn-round u-mg-top--small masoleanjam-icon"
                    selectedUsers={this.state.partners}
                    submit={this.addPartners}
                  ></UsersSelect>
                ) : (
                  <BtnRound
                    className="u-mg-top--small masoleanjam-icon"
                    onClick={() =>
                      userActions.failure(
                        "لطفاً ابتدا مسئول انجام این برنامه را مشخص نمایید."
                      )
                    }
                  />
                )}

                {this.state.isEditing ? (
                  <div className="u-mg-top--small d-flex justify-content-center">
                    <button
                      className="u-text-white u-fn-12 rounded-pill border-0 btn btn-primary mx-1 w-50 py-3"
                      onClick={this.handleCancel}
                    >
                      انصراف
                    </button>
                    <button
                      className="u-text-white u-fn-12 rounded-pill border-0 btn btn-primary mx-1 w-50 py-3"
                      onClick={(e) => {
                        if (
                          this.state.step_description === null ||
                          this.state.step_description.replace(/\s/g, "")
                            .length === 0
                        ) {
                          userActions.failure("لطفاً شرح گام را وارد کنید.");
                        } else if (this.state.start_at_temp === "") {
                          userActions.failure("لطفاً تاریخ شروع را مشخص کنید.");
                        } else if (this.state.finish_at_temp === "") {
                          userActions.failure(
                            "لطفاً تاریخ پایان را مشخص کنید."
                          );
                        } else if (
                          new Date(this.state.finish_at_temp).getTime() <
                          new Date(this.state.start_at_temp).getTime()
                        ) {
                          userActions.failure(
                            "تاریخ پایان نمی تواند قبل از شروع آن باشد."
                          );
                        } else if (this.state.responsible_person === "") {
                          userActions.failure(
                            "لطفاً مسئول انجام را انتخاب کنید."
                          );
                        } else if (
                          this.state.partners.some(
                            (partner) =>
                              partner.id ===
                              this.state.referrer_person_object.id
                          )
                        ) {
                          userActions.failure(
                            "مسئول انجام / آگاهی نمی تواند جزو همکاران باشد."
                          );
                        } else {
                          this.handleEdit(e, null, "submit");
                        }
                      }}
                    >
                      ثبت
                    </button>
                  </div>
                ) : (
                  <button
                    className="btn rounded-pill mt-3 mx-auto w-75 bg-primary text-white py-3 font-weight-bold u-fn-12 text-center d-flex justify-content-center align-items-center"
                    onClick={() => {
                      if (
                        this.state.step_description === null ||
                        this.state.step_description.replace(/\s/g, "")
                          .length === 0
                      ) {
                        userActions.failure("لطفاً شرح گام را وارد کنید.");
                      } else if (this.state.start_at_temp === "") {
                        userActions.failure("لطفاً تاریخ شروع را مشخص کنید.");
                      } else if (this.state.finish_at_temp === "") {
                        userActions.failure("لطفاً تاریخ پایان را مشخص کنید.");
                      } else if (
                        this.state.finish_atUnix < this.state.start_atUnix
                      ) {
                        userActions.failure(
                          "تاریخ پایان نمی تواند قبل از شروع آن باشد."
                        );
                      } else if (this.state.responsible_person === "") {
                        userActions.failure(
                          "لطفاً مسئول انجام را انتخاب کنید."
                        );
                      } else if (
                        this.state.partners.some(
                          (partner) =>
                            partner.id === this.state.referrer_person_object.id
                        )
                      ) {
                        userActions.failure(
                          "مسئول انجام / آگاهی نمی تواند جزو همکاران باشد."
                        );
                      } else {
                        this.handleAddStep();
                      }
                    }}
                  >
                    افـزودن گـام
                  </button>
                )}
              </Container>
              <Form>
                <Textarea
                  className="u-fn-12"
                  value={this.safeValue(this.state.step_description)}
                  onChange={(e) =>
                    this.setState({ step_description: e.target.value })
                  }
                />
              </Form>
            </Card>
            {this.state.steps && this.state.steps.length ? (
              <List className="left-part__list u-mg-top--small">
                <Banner />
                {this.state.steps &&
                  this.state.steps.length &&
                  Array.from({ length: this.state.steps.length }).map(
                    (_, i) => (
                      <ListItem
                        i={i}
                        key={i + 1}
                        steps={this.state.steps}
                        start_atUnFormated={this.state.start_atUnFormated}
                        start_atUnix={this.state.start_atUnix}
                        finish_atUnFormated={this.state.finish_atUnFormated}
                        finish_atUnix={this.state.finish_atUnix}
                        onMontafi={(e) => {
                          e.preventDefault();
                          this.setState({
                            steps: this.state.steps.map((step) => {
                              if (step.id === this.state.steps[i].id) {
                                return {
                                  ...step,
                                  status:
                                    step.status === "active"
                                      ? "deactive"
                                      : "active",
                                };
                              }
                              return step;
                            }),
                          });
                        }}
                        onEdit={this.handleEdit}
                        onMasoleanjam={() => this.handleMasoleanjam(i)}
                        getNameById={this.getNameById}
                      />
                    )
                  )}
              </List>
            ) : (
              ""
            )}
            <div
              style={{ width: "30%" }}
              className={`d-flex flex-row-reverse  mx-auto justify-content-center${
                this.state.steps && this.state.steps.length
                  ? ""
                  : "round-div__container--submit--bottom"
              }`}
            >
              <button
                className="btn btn-primary  text-white  u-fn-14 rounded-pill position-relative font-weight-bold mx-1 border-0 w-50 py-3"
                onClick={() => {
                  this.props
                    .dispatch(
                      userActions.question(
                        "انصراف",
                        "آیا از انصراف مطمئن هستید؟"
                      )
                    )
                    .then((r) => {
                      if (r.value) {
                        this.props.onRequestClose();
                      }
                    });
                }}
                style={{ cursor: "pointer" }}
              >
                <p className="m-0">انصراف</p>
              </button>

              <button
                className="btn-primary  text-white  u-fn-14 position-relative font-weight-bold rounded-pill mx-1 border-0 w-50 py-3 "
                type="submit"
                onClick={(e) => {
                  if (this.state.subject === "") {
                    userActions.failure("لطفاً موضوع را وارد کنید.");
                  } else if (this.state.mehvar === "") {
                    userActions.failure("لطفاً محور را انتخاب کنید.");
                  } else if (
                    this.state.priority_status === "" &&
                    this.state.priority_status_temp === ""
                  ) {
                    userActions.failure("لطفاً اولویت را انتخاب کنید.");
                  } else if (this.state.steps.length === 0) {
                    userActions.failure("لطفاً گام اجرای برنامه را وارد کنید.");
                  } else {
                    userActions.successToast("اقدام اصلاحی با موفقیت انجام شد");
                    this.postData(e);
                    this.props.onRequestClose();
                  }
                }}
                style={{ cursor: "pointer" }}
              >
                ثبت
              </button>
            </div>
          </Container>
        </Container>
        <RightPart
          state={this.state}
          setState={this.setState}
          safeValue={this.safeValue}
          onPriorityStatusTemp={(num) =>
            this.setState({
              priority_status_temp: num,
            })
          }
          onDescription={(e) => this.setState({ description: e.target.value })}
          onSubject={(e) => this.setState({ subject: e.target.value })}
          onMehvar={(e) =>
            this.setState({
              mehvar: e.name,
              mehvar_object: { name: e.name, id: e.id },
            })
          }
        />
        <Modal
          isOpen={this.state.MonitorModal}
          contentLabel="Monitor Modal"
          portalClassName="full_screen_modal"
        >
          <ModalPartners
            partners={
              this.state.steps && this.state.steps.length
                ? this.state.steps[this.state.modalPartnerNum].partners
                : []
            }
            onClose={this.handleCloseMasoleanjam}
            getNameById={this.getNameById}
          />
        </Modal>
      </Container>
    );
  }
}

class RightPart extends Component {
  constructor(props) {
    super(props);
    this.errorMsgs = {
      autoFill: "این فیلد به صورت خودکار توسط سامانه تکمیل می گردد.",
      activePriority: "این فیلد به صورت خودکار توسط سامانه تکمیل می گردد.",
    };
    this.mehvar_options = [{ name: "بهبود کیفیت", id: 1 }];
    this.priorityValues = [
      {
        className: "priority--high",
        classNameText: "u-text-red",
        Text: "بالا",
        num: 5,
      },
      {
        className: "priority--medium",
        classNameText: "u-text-yellow",
        Text: "متوسط",
        num: 3,
      },
      {
        className: "priority--low",
        classNameText: "u-text-green",
        Text: "کم",
        num: 1,
      },
    ];
  }

  isPriorityActive = (num) => {
    const { priority_status, priority_status_temp } = this.props.state;
    return num === Number(priority_status || priority_status_temp);
  };

  onPriority = (num) => {
    const { state, onPriorityStatusTemp } = this.props;
    state.priority_status
      ? userActions.failure(this.errorMsgs.activePriority)
      : onPriorityStatusTemp(num);
  };

  render() {
    const { safeValue, state, onDescription, onSubject, onMehvar } = this.props;
    const { subject, eop_number, mehvar_object, description } = state;
    const startFormatted = formatDate(safeValue(state.start_at));
    const finsishFormatted = formatDate(safeValue(state.finish_at));
    const finishDataTip = finsishFormatted
      ? `تاریخ پایان ${finsishFormatted}`
      : "";
    const startDataTip = startFormatted ? `تاریخ شروع ${startFormatted}` : "";

    return (
      <Container className="right-part">
        <Card className="right-part__card u-background-blue">
          <div className=" mt-4 border border-white rounded-pill w-100 py-3 position-relative">
            <TransparentInput
              className="u-caret-white u-text-white u-fn-14 "
              placeholder="موضوع"
              value={safeValue(subject)}
              onChange={onSubject}
            />
          </div>
          <div className="mt-2 bg-white rounded-pill w-100 d-flex justify-content-between align-items-center py-2 flex-row-reverse">
            <div className="text-primary w-50 d-flex justify-content-center align-items-center">
              <p className="m-0">{safeValue(eop_number)}</p>
            </div>
            <div className="text-primary w-50  d-flex justify-content-center align-items-center">
              <p className="m-0">شمـاره</p>
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center mt-3">
            <button
              onClick={() => userActions.failure(this.errorMsgs.autoFill)}
              data_tip={finishDataTip}
              className="u-text-blue u-fn-12 btn bg-white rounded-pill d-flex justify-content-center align-items-center"
              style={{ width: "47%", color: "#104c82" }}
            >
              <p className="m-0 font-weight-bold py-1">
                <span>تاریخ پایان </span>
                <span>{finsishFormatted}</span>
              </p>
            </button>
            <button
              onClick={() => userActions.failure(this.errorMsgs.autoFill)}
              data_tip={startDataTip}
              className="u-text-blue u-fn-12 btn bg-white rounded-pill d-flex justify-content-center align-items-center"
              style={{ width: "47%", color: "#104c82" }}
            >
              <p className="m-0 font-weight-bold py-1">
                <span>تاریخ شروع </span>
                <span>{startFormatted}</span>
              </p>
            </button>
          </div>

          <Select
            className="u-mg-top--small custom-select-2 select-special"
            placeholder="بخش"
            value={mehvar_object}
            onChange={onMehvar}
            options={this.mehvar_options}
            getOptionLabel={(opt) => opt.name}
            getOptionValue={(opt) => opt.id}
          />
          <div
            style={{
              height: "42%",
              borderRadius: "12px",
            }}
            className="bg-white mt-3 px-3 rounded-lg"
          >
            <Textarea
              className="u-fn-13"
              placeholder="توضیحات"
              value={safeValue(description)}
              onChange={onDescription}
            />
          </div>
          <div
            style={{ height: "95px" }}
            className="Priority_box bg-white mt-3  d-flex  position-relative bg-danger w-100 border-50 position-relative py-4"
          >
            {this.priorityValues.map(
              ({ className, classNameText, Text, num }, i) => (
                <Priority
                  key={i}
                  className={className}
                  classNameText={classNameText}
                  Text={Text}
                  active={this.isPriorityActive(num)}
                  onClick={() => this.onPriority(num)}
                />
              )
            )}
          </div>
          <ReactTooltip type="dark" />
        </Card>
      </Container>
    );
  }
}

class ModalPartners extends Component {
  render() {
    const { partners, onClose, getNameById } = this.props;

    return (
      <div className="modal--show-partners">
        <div className="banner">
          <p>مسئول انجام و همکاران</p>
          <button onClick={onClose}>&#10005;</button>
        </div>
        <img src={standingPerson} alt="standingPerson" />
        <ul>
          {partners && partners.length
            ? partners.map((id, i) => {
                const { fn, ln, post } = getNameById(+id, false, false, true);
                return (
                  <li key={i}>
                    <div>{`${fn} ${ln}`}</div>
                    <div>{post}</div>
                  </li>
                );
              })
            : "xxxx"}
        </ul>
      </div>
    );
  }
}

class Container extends Component {
  render() {
    return (
      <div className={`${this.props.className}`}>{this.props.children}</div>
    );
  }
}

class Card extends Component {
  render() {
    return (
      <div className={`${this.props.className}`}>{this.props.children}</div>
    );
  }
}

class ProgressBar extends Component {
  getUnitString = (value, unit) => {
    return `${value} ${unit}`;
    // return `${value} ${unit}${value > 1 ? "s" : ""}`;
  };

  formatDuration = (seconds) => {
    if (seconds === 0) return "اتمام زمان انجام کار";

    const units = [
      { unit: "سال", duration: 60 * 60 * 24 * 365 },
      { unit: "روز", duration: 60 * 60 * 24 },
      { unit: "ساعت", duration: 60 * 60 },
      // { unit: "دقیقه", duration: 60 },
      // { unit: "ثانیه", duration: 1 },
    ];

    const result = units
      .map(({ unit, duration }) => {
        const value = Math.floor(seconds / duration);
        seconds -= value * duration;
        return value > 0 ? this.getUnitString(value, unit) : null;
      })
      .filter((unitString) => unitString !== null);

    return result.length === 1 ? result[0] : result.join(" و ");
  };

  render() {
    const {
      start_atUnFormated,
      start_atUnix,
      finish_atUnFormated,
      finish_atUnix,
      start_at,
      finish_at,
    } = this.props;

    const startInSecondes = Math.floor(new Date(start_at).getTime() / 1000);
    const finishInSecondes = Math.floor(new Date(finish_at).getTime() / 1000);
    const now = Math.floor(new Date().getTime() / 1000);
    const passed = now - startInSecondes;
    const total = finishInSecondes - startInSecondes;
    const remaining = total - passed;
    const percent = Math.floor((passed / total) * 100);
    const progressVal = remaining > 0 ? percent : 100;

    const tooltipVal = this.formatDuration(remaining);

    return (
      <div className="left-part__list__item__progress-bar">
        <Progress
          value={progressVal}
          striped
          color="success"
          className="bar"
          data-tip={tooltipVal}
        />
        <p className="dates">
          <span>{formatDate(finish_at)}</span>
          <span>{formatDate(start_at)}</span>
        </p>
      </div>
    );
  }
}

class Form extends Component {
  render() {
    return (
      <div className="form-container">
        <p className="form-container__text">شـرح فعـالیت هـای اقـدام اصلاحـی</p>
        <div className="u-background-white form-container__input">
          {this.props.children}
        </div>
      </div>
    );
  }
}

class Textarea extends Component {
  render() {
    return (
      <textarea
        className={`special-textarea ${this.props.className}`}
        placeholder={`${this.props.placeholder || ""}`}
        value={this.props.value || ""}
        onChange={this.props.onChange}
      />
    );
  }
}

class TransparentInput extends Component {
  render() {
    return (
      <input
        className={`transparent-input ${this.props.className}`}
        placeholder={`${this.props.placeholder}`}
        value={this.props.value}
        onChange={this.props.onChange}
      />
    );
  }
}

class BtnRound extends Component {
  render() {
    return (
      <>
        <button
          className={`btn-round ${this.props.className}`}
          onClick={this.props.onClick}
          data-tip={this.props.data_tip}
        ></button>
        <ReactTooltip type="dark" />{" "}
      </>
    );
  }
}

class Priority extends Component {
  render() {
    return (
      <div
        className={`priority ${this.props.className} ${
          this.props.active ? "u-border-blue" : ""
        }`}
        onClick={this.props.onClick}
      >
        <p className={`u-fn-14 ${this.props.classNameText}`}>
          {this.props.Text}
        </p>
      </div>
    );
  }
}

class List extends Component {
  render() {
    return <ul className={`${this.props.className}`}>{this.props.children}</ul>;
  }
}

class Banner extends Component {
  render() {
    return (
      <li className="left-part__list__banner" key="0">
        <div className="left-part__list__banner__child">ردیف</div>
        <div className="left-part__list__banner__child">
          شـرح فعـالیت هـای اقـدام اصلاحـی
        </div>
        <div className="left-part__list__banner__child">
          تاریـخ شـروع و پایـان
        </div>
        <div className="left-part__list__banner__child">مسئـول انجـام</div>
        <div className="left-part__list__banner__child">همکـاران</div>
        <div className="left-part__list__banner__child">عملیـات</div>
      </li>
    );
  }
}

class ListItem extends Component {
  render() {
    const {
      steps,
      i,
      onEdit,
      onMontafi,
      onMasoleanjam,
      start_atUnFormated,
      start_atUnix,
      finish_atUnFormated,
      finish_atUnix,
      getNameById,
    } = this.props;
    const {
      status,
      description,
      responsible_person,
      partners,
      start_at,
      finish_at,
    } = steps[i];

    return (
      <li className={`left-part__list__item ${status}`}>
        <p className="left-part__list__item__text">{i + 1}</p>
        <p className="left-part__list__item__text" data-tip={description}>
          {description.length > 25
            ? description.slice(0, 25) + "..."
            : description}
        </p>
        <ProgressBar
          start_atUnFormated={start_atUnFormated}
          start_atUnix={start_atUnix}
          finish_atUnFormated={finish_atUnFormated}
          finish_atUnix={finish_atUnix}
          start_at={start_at}
          finish_at={finish_at}
        />
        <p className="left-part__list__item__text">
          {getNameById(responsible_person)}
        </p>
        <ListItemBtnContainer>
          {partners && partners.length ? (
            <BtnRound
              data_tip="همکاران"
              className="masoleanjam-icon"
              onClick={onMasoleanjam}
            />
          ) : (
            <BtnRound data_tip="همکاران" className="masoleanjam-black-icon" />
          )}
        </ListItemBtnContainer>
        <ListItemBtnContainer>
          {status !== "deactive" && (
            <BtnRound
              data_tip="ویرایش"
              className="edit-icon"
              onClick={(e) => onEdit(e, i, "setup")}
            />
          )}
          <BtnRound
            data_tip={status === "deactive" ? "لغو منتفی کردن" : "منتفی"}
            className={`montafi${status === "deactive" ? "-dark" : ""}-icon`}
            onClick={onMontafi}
          />
        </ListItemBtnContainer>
      </li>
    );
  }
}

class ListItemBtnContainer extends Component {
  render() {
    return (
      <div className="left-part__list__item__btn-container">
        {this.props.children}
      </div>
    );
  }
}

const Eop = connect((state) => ({
  globalStorage: state.globalStorage,
}))(Eop_);

export { Eop };
